import "./src/css/style.css";
import { wrapMDX } from "./root-mdx";

export const wrapRootElement = wrapMDX